import { Page } from '@/core/architecture'

import { ArtistGalleryTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistGallery Page
 * Implemented as a practical sample.
 */
export const ArtistGallery: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistGalleryTemplate state={state} {...actions} />
}
